import SubscriptionService from "@/services/SubscriptionService";
import { useLocale } from "@/store/locale-store";

interface NotifyStockParams {
  email: string;
  productSlug: string;
  sku?: string;
}

export function useNotifications() {
  const { countryCode } = useLocale();

  return {
    notifyStock: ({
      email,
      productSlug,
      sku = "",
    }: NotifyStockParams): Promise<boolean> => {
      return SubscriptionService.notifyStock({
        email,
        productName: productSlug,
        countryCode,
        sku,
      });
    },
    notifyStockAndSubscribe: ({
      email,
      productSlug,
      sku = "",
    }: NotifyStockParams): Promise<boolean> => {
      return SubscriptionService.notifyStockAndSubscribe({
        email,
        productName: productSlug,
        countryCode,
        sku,
      });
    },
    // AtH 게임 릴리즈 구독 (countryCode 불필요). slug 생략=전체 신작 토픽, 로그인=token / 게스트=email.
    // source 는 동의 provenance(기본 "ath-landing"); 새 유입 표면이 생기면 호출부에서 넘김.
    notifyGameRelease: ({
      slug,
      email,
      token,
      source,
    }: {
      slug?: string;
      email?: string;
      token?: string;
      source?: string;
    }): Promise<boolean> => {
      return SubscriptionService.notifyGameRelease({
        slug,
        email,
        token,
        source,
      });
    },
  };
}
